/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { spacing } from '../../shared/theme/spacing';
import { FilterSheetButton } from '../../shared/filters/FilterSheetButton'
import { FilterSheetModal } from '../../shared/filters/FilterSheetModal'
import { OperationalFilterFieldLabel, OperationalFilterSegmentedRow } from '../../shared/filters/OperationalFilterPrimitives'
import { useOperationalFilterLayout } from '../../shared/filters/useOperationalFilterLayout';
import type { PromotionListFilter } from '../application/usePromotionsListScreen';

const FILTER_OPTIONS: Array<{ value: PromotionListFilter; label: string; shortLabel?: string }> = [
  // "Activas" incluye Programadas a propósito (una promo futura no tiene que
  // desaparecer del listado default) — el label lo dice.
  { value: 'active', label: 'Activas y programadas', shortLabel: 'Activas' },
  { value: 'inactive', label: 'Inactivas / vencidas', shortLabel: 'Inactivas' },
  { value: 'all', label: 'Todas', shortLabel: 'Todas' },
];

type Props = {
  filter: PromotionListFilter;
  onFilterChange: (value: PromotionListFilter) => void;
  hasActiveFilters: boolean;
  onClearFilters: () => void;
  /** Si true, no renderiza el botón (el padre lo pone en la desk toolbar). */
  hideTrigger?: boolean;
  /** Control externo del sheet (PC toolbar). */
  sheetOpen?: boolean;
  onSheetOpenChange?: (open: boolean) => void;
};

export function PromotionsFiltersPanel({
  filter,
  onFilterChange,
  hasActiveFilters,
  onClearFilters,
  hideTrigger = false,
  sheetOpen: sheetOpenProp,
  onSheetOpenChange,
}: Props) {
  const { layoutWide } = useOperationalFilterLayout();
  const [internalOpen, setInternalOpen] = useState(false);
  const sheetOpen = sheetOpenProp ?? internalOpen;
  const setSheetOpen = onSheetOpenChange ?? setInternalOpen;
  const activeCount = hasActiveFilters ? 1 : 0;

  const filterOptions = FILTER_OPTIONS.map((opt) => ({
    value: opt.value,
    label: opt.label,
    shortLabel: opt.shortLabel,
    accessibilityLabel: `Filtro: ${opt.label}`,
  }));

  return (
    <>
      {!hideTrigger ? (
        <FilterSheetButton
          activeCount={activeCount}
          onOpen={() => setSheetOpen(true)}
          accessibilityLabel="Abrir filtros de promociones"
          variant={layoutWide ? 'desk' : 'ticket'}
        />
      ) : null}
      <FilterSheetModal
        visible={sheetOpen}
        onClose={() => setSheetOpen(false)}
        onApply={() => setSheetOpen(false)}
        onClear={() => {
          onClearFilters();
        }}
        hasActiveDraft={hasActiveFilters}
        appearance="ticket"
        title="Filtros"
      >
        <View style={styles.section}>
          <OperationalFilterFieldLabel>Estado</OperationalFilterFieldLabel>
          <OperationalFilterSegmentedRow
            options={filterOptions}
            value={filter}
            onChange={onFilterChange}
            ticketTone
          />
        </View>
      </FilterSheetModal>
    </>
  );
}

const styles = StyleSheet.create({
  section: {
    gap: spacing.sm,
  },
});
